import React, { useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { User } from 'api/models';
import {
  ReactivateMemberMutationType,
  SUBSCRIPTION_KEY,
  useForceSyncSubscriptionMutation,
  useSubscriptionQuery,
} from 'queries/billing';
import { PaymentStatus, PaymentStatuses } from '../../manage-license';
import { EstimateModal } from './estimate';

interface Props {
  user: User;
  onSubmit: (user: User) => void;
  isProcessing: boolean;
  isSuccess: boolean;
  isError: boolean;
  onCancel: () => void;
  visible: boolean;
  estimateMutation: ReactivateMemberMutationType;
}

export const ReactivationBillingWrapper = ({
  user,
  onSubmit,
  isProcessing,
  isSuccess,
  isError,
  onCancel,
  visible,
  estimateMutation,
}: Props) => {
  const queryClient = useQueryClient();
  const [showEstimate, setShowEstimate] = useState(visible);
  const { data: subscription } = useSubscriptionQuery();
  const { mutateAsync: forceSyncSubscription } =
    useForceSyncSubscriptionMutation();

  useEffect(() => {
    setShowEstimate(visible);
  }, [visible]);

  useEffect(() => {
    (async () => {
      if (isSuccess && subscription?.subscriptionId) {
        await forceSyncSubscription(subscription?.subscriptionId);
        queryClient.invalidateQueries(SUBSCRIPTION_KEY);
      }
    })();
  }, [
    forceSyncSubscription,
    isSuccess,
    queryClient,
    subscription?.subscriptionId,
  ]);

  const onConfirm = () => {
    onSubmit(user);
    setShowEstimate(false);
  };
  const paymentStatus = isProcessing
    ? PaymentStatuses.Processing
    : isSuccess
    ? PaymentStatuses.Processed
    : isError
    ? PaymentStatuses.ProcessingFailed
    : undefined;

  return (
    <>
      {showEstimate && (
        <EstimateModal
          subscription={subscription}
          userId={user.userId}
          onOk={onConfirm}
          onCancel={onCancel}
          estimateMutation={estimateMutation}
        />
      )}
      <PaymentStatus
        paymentStatus={paymentStatus}
        onPaymentStatusClosed={onCancel}
        openSelfServePortalAfterFailure={false}
      />
    </>
  );
};
